import axios from "axios";

export function getCenterPersonList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "CenterPerson/getall", config);
}

// export function postCenterPerson(data, rolId) {
//   const config = {
//     params: {
//       rolId: rolId,
//     },
//   };
//   return axios.post(process.env.VUE_APP_API_URL + "CenterPerson/add", data, config);
// }

// export function postNewCenterPerson(data) {
//   return axios.post(process.env.VUE_APP_API_URL + "Auth/oyspersonregister", data);
// }

// export function updateCenterPerson(data, appOperationClaimId, rolId) {
//   const config = {
//     params: {
//       appOperationClaimId: appOperationClaimId,
//       rolId: rolId,
//     },
//   };
//   return axios.put(process.env.VUE_APP_API_URL + "CenterPerson/edit", data, config);
// }

export function addCenterPerson(data, rolId) {
  const config = {
    params: {
      rolId: rolId,
    },
  };
  return axios.post(process.env.VUE_APP_API_URL + "CenterPerson/add", data, config);
}

export function postNewCenterPerson(data) {
  return axios.post(process.env.VUE_APP_API_URL + "CenterPerson/addnew", data);
}

export function updateCenterPerson(data, appOperationClaimId, rolId) {
  const config = {
    params: {
      appOperationClaimId: appOperationClaimId,
      rolId: rolId,
    },
  };
  return axios.put(process.env.VUE_APP_API_URL + "CenterPerson/update", data, config);
}

export function deleteCenterPerson(centerPersonId) {
  const config = {
    params: {
      centerPersonId: centerPersonId,
    },
  };
  return axios.delete(process.env.VUE_APP_API_URL + "CenterPerson/delete", config);
}

//Center Person Type
export function getCenterPersonTypeList() {
  return axios.get(process.env.VUE_APP_API_URL + "CenterPerson/CenterPersonTypeList");
}

export function getCenterPersonDistinctionList() {
  return axios.get(process.env.VUE_APP_API_URL + "CenterPerson/CenterPersonDistinctionList");
}

export function getUserListNotTeacher(data) {
  const config = {
    params: {
      centerId: data.centerId,
      filter: data.filter
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "CenterPerson/UserListNotTeacher", config);
}
